// src/utils/errorHandler.ts
import { apiFetch } from '../apiClient';
import { API_URL } from '../Config';

/**
 * Muestra un mensaje de error genérico al usuario y registra detalles en el backend.
 * @param error Error capturado
 * @param userMessage Mensaje opcional para mostrar al usuario (por defecto uno genérico)
 */
export function handleError(error: unknown, userMessage = 'Ocurrió un error inesperado. Por favor, intente nuevamente.') {
  // Mostrar mensaje genérico al usuario (puede ser con alert, toast, etc.)
  if (typeof window !== 'undefined') {
   //alert(userMessage); // Reemplazar por un sistema de notificaciones si existe
  }

  // Registrar detalles en el backend
  try {
    var url_api = API_URL;
    var logEndpoint = url_api ? url_api + '/ArcIndicador/log-error' : '/log-error';

    // Usamos fetch con mode 'no-cors' para evitar errores de bloqueo CORS
    fetch(logEndpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
        timestamp: new Date().toISOString(),
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      })
    }).catch(e => console.warn('Error al enviar log:', e));
    
  } catch (logError) {
    // Si falla el log, no hacer nada para evitar loops
  }
}
